module.exports = __webpack_public_path__ + "media/images/lesson_9/grupo-6fd334fe19fa3b619327691a70b75625.png";